var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "headphones_4_",
    "data-name": "headphones (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.345,
    height: 45.904,
    viewBox: "0 0 40.345 45.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55674",
    "data-name": "Group 55674",
    transform: "translate(5.379 18.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55673",
    "data-name": "Group 55673",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87431",
    "data-name": "Path 87431",
    d: "M95.035,210A4.039,4.039,0,0,0,91,214.034v10.938a4.035,4.035,0,0,0,8.069,0V214.034A4.039,4.039,0,0,0,95.035,210Z",
    transform: "translate(-91 -210)",
    fill: "#444"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55676",
    "data-name": "Group 55676",
    transform: "translate(0 21.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55675",
    "data-name": "Group 55675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87432",
    "data-name": "Path 87432",
    d: "M33.69,243.5a6.675,6.675,0,0,1,.115-1.133,4.027,4.027,0,0,0-2.8,3.822v5.559a4.026,4.026,0,0,0,2.8,3.822,6.674,6.674,0,0,1-.115-1.133Z",
    transform: "translate(-31 -242.366)",
    fill: "#444"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55678",
    "data-name": "Group 55678",
    transform: "translate(16.138 18.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55677",
    "data-name": "Group 55677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87433",
    "data-name": "Path 87433",
    d: "M225.793,210a4.039,4.039,0,0,0-4.034,4.034v10.938a4.039,4.039,0,0,0,4.034,4.034,3.979,3.979,0,0,0,1.156-.189A4.026,4.026,0,0,1,223.1,231.7h-4.282a4.035,4.035,0,1,0,0,2.69H223.1a6.732,6.732,0,0,0,6.724-6.724V214.034A4.039,4.039,0,0,0,225.793,210Z",
    transform: "translate(-211 -210)",
    fill: "#444"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55680",
    "data-name": "Group 55680",
    transform: "translate(37.541 21.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55679",
    "data-name": "Group 55679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87434",
    "data-name": "Path 87434",
    d: "M449.722,242.366a6.676,6.676,0,0,1,.115,1.133v10.938a6.675,6.675,0,0,1-.115,1.133,4.026,4.026,0,0,0,2.8-3.822v-5.559A4.027,4.027,0,0,0,449.722,242.366Z",
    transform: "translate(-449.722 -242.366)",
    fill: "#444"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55682",
    "data-name": "Group 55682",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55681",
    "data-name": "Group 55681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87435",
    "data-name": "Path 87435",
    d: "M51.173,0A20.2,20.2,0,0,0,31,20.172v.034a6.659,6.659,0,0,1,2.751-1.249,17.462,17.462,0,0,1,34.842,0,6.662,6.662,0,0,1,2.751,1.249v-.034A20.2,20.2,0,0,0,51.173,0Z",
    transform: "translate(-31)",
    fill: "#444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.562c36bfb9ed2d6ba72ff76d64f7dcc0.svg";
export { ForwardRef as ReactComponent };